/* eslint-disable */
import { SVGProps } from "react";
const SvgAllAdders = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.734}
    height={17.734}
    fill="currentColor"
    viewBox="0 0 17.734 17.734"
    {...props}
  >
    <path
      data-name="Path 895"
      d="M15.137 2.6A8.867 8.867 0 0 0 2.6 15.137 8.867 8.867 0 0 0 15.137 2.6Zm-.35 8.4a3.047 3.047 0 0 1-4.859-.677.52.52 0 1 1 .913-.5 2.006 2.006 0 1 0 1.824-2.963 1.968 1.968 0 0 0-1.391.511L7 11.189a2.8 2.8 0 0 1-1.872.724 3.047 3.047 0 0 1-.093-6.092 3.063 3.063 0 0 1 2.807 1.663.52.52 0 0 1-.926.472 2.02 2.02 0 0 0-1.852-1.1 2.008 2.008 0 0 0 .062 4.014 1.762 1.762 0 0 0 1.18-.46l4.276-3.81a3.045 3.045 0 0 1 4.205 4.4Z"
    />
  </svg>
);

export default SvgAllAdders;
